<!-- 营销中心 平台营销工具 会员卡权益 流水统计 -->
<template>
  <scroll-layout class="flow-statistics-list">
    <template slot="header">
      <ykc-warm-tip
        type="warning"
        v-if="topTipStatus"
        :description="topTip"
        @click="topTipStatus = false"></ykc-warm-tip>
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParam"
        @clean="handleSearchClean"
        @click="handleSearchConfirm"></ykc-search>
    </template>
    <div>
      <ykc-table
        ref="YkcTable"
        operateFixedType="right"
        :data="tableData"
        :title="tableTitle"
        :columns="tableColumns"
        :operateButtons="tableOperateButtons">
        <template #headerButtons>
          <div class="table-header-button">
            <ykc-button type="plain" @click="doExportFile">导出</ykc-button>
          </div>
        </template>
        <ykc-pagination
          align="right"
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :page-size.sync="pageInfo.size"
          :current-page.sync="pageInfo.current"
          @current-change="handlePaginationCurrentChange"
          @size-change="handlePaginationSizeChange"></ykc-pagination>
      </ykc-table>
    </div>
  </scroll-layout>
</template>

<script>
  import { offlineExport } from '@/utils';
  import { marketManage } from '@/service/apis';

  export default {
    name: 'memberCardEquityFlowList',
    data() {
      return {
        searchParam: {
          flowNumber: '', // 流水号
          relatedOrderNumber: '', // 关联订单号
          flowType: '', // 流水类型
          flowUser: '', // 流水对象
          orderAccount: '', // 下单账号
          vipCardType: '', // 会员卡类型
          flowTime: '', // 流水时间
          refundTime: '', // 售后退卡时间
          date: [],
          flowStartTime: '',
          flowEndTime: '',
          refundDate: [],
          refundStartTime: '',
          refundEndTime: '',
        },
        tableTitle: '会员卡流水统计', // 列表表格
        tableData: [],
        // 列表操作
        tableColumns: [
          { label: '流水号', prop: 'flowNumber', minWidth: '250px' },
          { label: '流水类型', prop: 'flowTypeName', minWidth: '150px' },
          { label: '流水对象', prop: 'flowUser', minWidth: '120px' },
          { label: '微信回执单号', prop: 'respNo', minWidth: '250px' },
          { label: '流水时间', prop: 'flowTime', minWidth: '250px' },
          { label: '流水金额', prop: 'amount', minWidth: '120px' },
          { label: '关联订单号', prop: 'orderNo', minWidth: '250px' },
          { label: '下单账号', prop: 'userAccount', minWidth: '250px' },
          { label: '会员卡类型', prop: 'vipCardType', minWidth: '120px' },
          { label: '卡片生效时间', prop: 'startTime', minWidth: '250px' },
          { label: '卡片失效时间', prop: 'endTime', minWidth: '250px' },
          { label: '售后退卡时间', prop: 'refundTime', minWidth: '250px' },
        ],
        pageInfo: {
          current: 1,
          size: 10,
          total: 0,
        },
      };
    },
    created() {
      this.searchParam.date = [];
      this.searchParam.flowStartTime = '';
      this.searchParam.flowEndTime = '';
      this.searchParam.refundDate = [];
      this.searchParam.refundStartTime = '';
      this.searchParam.refundEndTime = '';
      this.requestList();
    },
    computed: {
      searchData() {
        return [
          {
            key: 'flowNumber',
            type: 'input',
            label: '流水号',
            comName: 'YkcInput',
          },
          {
            key: 'orderNo',
            type: 'input',
            label: '关联订单号',
            comName: 'YkcInput',
          },
          {
            key: 'flowType',
            type: 'select',
            label: '流水类型',
            comName: 'YkcDropdown',
            data: [
              { id: '1', name: '会员卡售卡' },
              { id: '2', name: '会员卡退卡（用户）' },
              { id: '3', name: '会员卡退卡（后台）' },
            ],
          },
          {
            key: 'flowUser',
            type: 'select',
            label: '流水对象',
            comName: 'YkcDropdown',
            data: [
              { id: '1', name: '用户' },
              { id: '2', name: '世纪云安' },
            ],
          },
          {
            key: 'userAccount',
            type: 'input',
            label: '下单账号',
            comName: 'YkcInput',
          },
          {
            key: 'vipCardType',
            type: 'input',
            label: '会员卡类型',
            comName: 'YkcDropdown',
            data: [
              { id: '', name: '全部' },
              { id: '001', name: '月卡' },
              { id: '002', name: '季卡' },
              { id: '003', name: '年卡' },
            ],
          },
          {
            comName: 'YkcDatePicker',
            key: 'date',
            label: '流水时间',
            placeholder: '请选择流水时间',
          },
          {
            comName: 'YkcDatePicker',
            key: 'refundDate',
            label: '售后退卡时间',
            placeholder: '请选择流水时间',
          },
        ];
      },
    },
    methods: {
      /**
       * 请求列表数据
       */
      requestList() {
        const pageInfos = (({ current, size }) => ({ current, size }))(this.pageInfo);
        const reqParams = {
          ...pageInfos,
          ...this.searchParam,
        };

        // 使用真实的后端接口
        marketManage
          .queryMemberCardFlowList(reqParams)
          .then(res => {
            this.tableData = res.records || [];
            this.pageInfo.total = res.total || 0;
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 导出
       */
      doExportFile() {
        offlineExport({
          downloadType: 'marketing_export',
          jsonNode: {
            downloadKey: 'vip_card_flow_export',
            ...this.searchParam,
          },
        });
      },
      /**
       * 点击筛选查询按钮
       * */
      handleSearchConfirm(searchData) {
        this.pageInfo.current = 1;
        Object.assign(this.searchParam, searchData);
        if (searchData.date && searchData.date.length > 0) {
          [this.searchParam.flowStartTime, this.searchParam.flowEndTime] = searchData.date;
        } else {
          delete this.searchParam.flowStartTime;
          delete this.searchParam.flowEndTime;
        }
        if (searchData.refundDate && searchData.refundDate.length > 0) {
          [this.searchParam.refundStartTime, this.searchParam.refundEndTime] =
            searchData.refundDate;
        } else {
          delete this.searchParam.refundStartTime;
          delete this.searchParam.refundEndTime;
        }
        this.requestList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        Object.assign(this.searchParam, form);
      },
      /**
       * 设置初始化1-6个默认时间查询
       */
      setInitDateFn() {},
      /**
       * 分页器页数
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.requestList();
      },
      /**
       * 分页器条数
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.requestList();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .flow-statistics-list {
    .ykc-table {
      .el-table .el-table__row {
        .cell .userStatus {
          padding-left: 8px;
          position: relative;
        }

        .cell .userStatus::after {
          display: block;
          content: '';
          width: 5px;
          height: 5px;
          border-radius: 100%;
          background: #d0021b;
          position: absolute;
          top: 5.5px;
          left: 0;
        }

        .cell .status-blue::after {
          background: #4d8cfd;
        }

        .cell .status-green::after {
          background: #02c498;
        }

        .cell .status-black::after {
          background: #9b9b9b;
        }
      }

      .sealBtn {
        color: #4d8cfd;
        cursor: pointer;
      }
    }
  }
</style>
